import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { RoleAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    roles: PropTypes.object,
    deleteRole: PropTypes.func,
    getRoles: PropTypes.func,
    location: PropTypes.object,
  };

  componentDidMount() {
    this.props.getRoles(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteRole(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getRoles({ query: value });
  }

  render() {
    const {
      roles: { data: roles = [], links = [] } = {},
      getRoles = () => {},
      location = {},
      permissions = [],
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Role</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getRoles}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('role.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0 table-responsive">
              {roles?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {roles?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['role.delete', 'role.edit']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      <th>Name</th>
                      <th>Permissions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          ['role.delete', 'role.edit']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('role.edit') && (
                                <Link
                                  className="btn btn-info btn-sm"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('role.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                        <td>{row.name}</td>
                        <td>
                          {row.permissions?.map?.(p => p.name)?.join(', ')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  roles: state?.role?.list,
  permissions: state?.auth?.permissions,
});

const mapDispatchToProps = dispatch => ({
  deleteRole: id => dispatch(RoleAction.deleteRole(id)),
  getRoles: params => dispatch(RoleAction.getRoles(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
